/* =========================================================
   PH ANNOUNCEMENT BAR
   Rotación automática de mensajes
   ========================================================= */

class PHAnnouncementBar {
  constructor(element) {
    this.element = element;

    this.items = Array.from(
      element.querySelectorAll('[data-ph-announcement-item]')
    );

    this.interval = Number(
      element.dataset.interval || 5000
    );

    this.currentIndex = 0;
    this.timer = null;
    this.isPaused = false;

    if (!this.items.length) return;

    this.setup();
  }

  setup() {
    this.items.forEach((item, index) => {
      const isActive = index === 0;

      item.classList.toggle('is-active', isActive);
      item.classList.remove('is-leaving');
      item.setAttribute(
        'aria-hidden',
        isActive ? 'false' : 'true'
      );
    });

    if (this.items.length < 2) return;

    this.bindEvents();
    this.start();
  }

  bindEvents() {
    this.element.addEventListener(
      'mouseenter',
      () => this.pause()
    );

    this.element.addEventListener(
      'mouseleave',
      () => this.resume()
    );

    this.element.addEventListener(
      'focusin',
      () => this.pause()
    );

    this.element.addEventListener(
      'focusout',
      () => this.resume()
    );

    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) {
          this.pause();
        } else {
          this.resume();
        }
      }
    );
  }

  show(index) {
    const currentItem = this.items[this.currentIndex];
    const nextItem = this.items[index];

    if (!currentItem || !nextItem) return;
    if (currentItem === nextItem) return;

    currentItem.classList.remove('is-active');
    currentItem.classList.add('is-leaving');
    currentItem.setAttribute('aria-hidden', 'true');

    nextItem.classList.remove('is-leaving');
    nextItem.classList.add('is-active');
    nextItem.setAttribute('aria-hidden', 'false');

    window.setTimeout(() => {
      currentItem.classList.remove('is-leaving');
    }, 450);

    this.currentIndex = index;
  }

  next() {
    const nextIndex =
      (this.currentIndex + 1) % this.items.length;

    this.show(nextIndex);
  }

  start() {
    this.stop();

    this.timer = window.setInterval(() => {
      if (!this.isPaused) {
        this.next();
      }
    }, this.interval);
  }

  stop() {
    if (!this.timer) return;

    window.clearInterval(this.timer);
    this.timer = null;
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    this.isPaused = false;
  }

  destroy() {
    this.stop();
  }
}

function initializePHAnnouncementBars(container = document) {
  const bars = container.querySelectorAll(
    '[data-ph-announcement]:not([data-ph-initialized])'
  );

  bars.forEach((bar) => {
    bar.dataset.phInitialized = 'true';
    bar.phAnnouncementInstance =
      new PHAnnouncementBar(bar);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializePHAnnouncementBars();
});

/* Compatibilidad con el editor de Shopify */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializePHAnnouncementBars(event.target);
  }
);

document.addEventListener(
  'shopify:section:unload',
  (event) => {
    const bar = event.target.querySelector(
      '[data-ph-announcement]'
    );

    if (bar?.phAnnouncementInstance) {
      bar.phAnnouncementInstance.destroy();
    }
  }
);